import React from 'react';

const Zipcode = ({ rowData }) => {
  const { carrier, zipcode } = rowData;

  const { zipcode: carrierZipcode } = carrier || {};

  return <div>{(zipcode || carrierZipcode || '').toUpperCase()}</div>;
};

export default Zipcode;
